export default [
  {
    path: '/signin',
    name: 'signin',
    component: () => import('@/pages/user/Signin.vue'),
    meta: {
      requiresAuth: false,
      title: 'Вход в систему',
      layout: 'auth'
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/pages/user/Signup.vue'),
    meta: {
      requiresAuth: false,
      title: 'Регистрация',
      layout: 'auth'
    }
  }
]
